import React from "react";
import { FlatButton, TextField } from "material-ui";

import BaseOverlay from "./base.jsx";
import InjectedSelect from "../injected-select.jsx";

const styles = {
  container: {
    marginTop: "1em"
  },
  selectContainer: {
    marginTop: "1em"
  }
};

class ChangeSeatsOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newSeats: {}
    };

    this.changeSeats = this.changeSeats.bind(this);
  }

  changeSeats() {
    this.props.onChangeSeats(this.state.newSeats);
  }

  componentDidMount() {
    const { tickets } = this.props;

    const event = tickets[0].event.id;

    this.chart = new seatsio.SeatingChart({
      divId: "seatingChart",
      workspaceKey: process.env.SEATS_IO_PUBLIC_KEY,
      event,
      selectableObjects: tickets.map(t => t.seat).filter(x => !!x),
      onObjectSelected: object => {
        const updated = { ...this.state.newSeats };

        // If one of the seats is deselected, set it first
        for (const ticket of tickets) {
          if (!updated[ticket.id]) {
            updated[ticket.id] = object.label;
            this.setState({ newSeats: updated });
            return;
          }
        }

        // Otherwise, just replace the first object
        const previous = updated[tickets[0].id];
        updated[tickets[0].id] = object.label;
        this.chart.deselectObjects([previous]);
        this.setState({ newSeats: updated });
      },
      onObjectDeselected: object => {
        const updated = { ...this.state.newSeats };
        Object.keys(updated).forEach(id => {
          if (updated[id] === object.label) {
            delete updated[id];
          }
        });
        this.setState({ newSeats: updated });
      }
    }).render();
  }

  render() {
    const { submitting, tickets, onClose } = this.props;
    const { newSeats } = this.state;

    const isReady = Object.keys(newSeats).length === tickets.length;

    return (
      <BaseOverlay
        onRequestClose={onClose}
        hideTitleAndFooterBorders={true}
        showCloseButton={true}
        useMuiDefaultStyle={true}
        actions={[
          <FlatButton label="Cancel" onClick={onClose} />,
          <FlatButton
            primary={true}
            disabled={submitting || !isReady}
            label={submitting ? "Changing seats..." : "Change seats"}
            onClick={this.changeSeats}
          />
        ]}
      >
        <h2>
          Change {tickets.length} seat{tickets.length !== 1 ? "s" : ""}
        </h2>
        <div style={styles.container}>
          Select the new seat{tickets.length !== 1 ? "s" : ""} below. The
          customer will not be charged. A confirmation email will be sent to the
          customer.
        </div>
        <div style={styles.selectContainer}>
          <div id="seatingChart" style={{ height: 400 }} />
        </div>
        <div style={styles.selectContainer}>
          When you click Change Seats, the following seating changes will be
          applied and the customer will receive updated tickets via email:
        </div>
        <div style={{ textAlign: "center", marginTop: "1em" }}>
          {tickets.map(t => {
            return (
              <div
                style={{
                  marginTop: "0.25em",
                  fontWeight: "bold",
                  fontSize: "1.25em"
                }}
              >
                {t.seat || "No seat"} →{" "}
                {this.state.newSeats[t.id] || "Not yet selected"}
              </div>
            );
          })}
        </div>
      </BaseOverlay>
    );
  }
}

export default ChangeSeatsOverlay;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/change-seats-overlay.jsx